import { useLocation } from 'react-router-dom'

/**
 * useQueryParam will try to find the string value of a query param
 * @param key the query param key
 * @param defaultValue optional default value to return
 * @returns the value and a boolean wether is was in the query params
 */
export function useQueryParam<T extends string = string>(key: string, defaultValue?: string): [T, boolean] {
  const { search } = useLocation()
  const params = new URLSearchParams(search)

  return [(params.get(key) || defaultValue || '') as T, params.has(key)]
}
